(function () {
  function formatMoney(cents) {
    var amount = (Number(cents || 0) / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function clean(text) {
    return String(text || '').replace(' - Sold out', '').trim();
  }

  function normalize(text) {
    return clean(text).toLowerCase().replace(/×/g, 'x').replace(/\s+/g, ' ').trim();
  }

  function key(text) {
    return normalize(text).replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  }

  function readJson(builder, selector, fallback) {
    var el = builder.querySelector(selector);
    try {
      return el ? JSON.parse(el.textContent) : fallback;
    } catch (e) {
      console.warn('GPB JSON error:', e);
      return fallback;
    }
  }

  function readOptionNames(builder) {
    return readJson(builder, '[data-gpb-option-names]', []);
  }

  function readVariants(builder) {
    return readJson(builder, '[data-gpb-main-variants]', []);
  }

  function getVariantOptions(variant) {
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1 || '', variant.option2 || '', variant.option3 || ''];
  }

  function selectedText(item) {
    if (!item) return '';

    var checked = item.querySelector('[data-gpb-optional-choice]:checked');
    if (checked) return clean(checked.dataset.fullText || checked.value);

    var select = item.querySelector('[data-gpb-select]');
    if (select) {
      var selectedOption = select.options[select.selectedIndex];
      return clean(selectedOption.dataset.fullText || selectedOption.textContent);
    }

    var single = item.querySelector('[data-gpb-single]');
    if (single) return clean(single.dataset.fullText || single.textContent);

    return '';
  }

  function getSelectedOptionMap(builder) {
    var map = {};

    builder.querySelectorAll('[data-gpb-item]').forEach(function (item) {
      var role = item.dataset.priceRole;
      var optionKey = key(item.dataset.optionKey || item.dataset.label);
      var value = selectedText(item);

      if (role === 'optional_variant') value = value || 'No Computer';

      if (role === 'variant_match' || role === 'optional_variant' || role === 'variant_price_adjust') {
        map[optionKey] = value;
      }
    });

    return map;
  }

  function findVariant(builder) {
    var optionNames = readOptionNames(builder);
    var variants = readVariants(builder);
    var selectedMap = getSelectedOptionMap(builder);

    return variants.find(function (variant) {
      var options = getVariantOptions(variant);

      return optionNames.every(function (optionName, index) {
        var selectedValue = selectedMap[key(optionName)];
        if (!selectedValue) return true;
        return normalize(options[index]) === normalize(selectedValue);
      });
    });
  }

  function getAddonTotal(builder) {
    var total = 0;

    builder.querySelectorAll('[data-gpb-item][data-price-role="addon"]').forEach(function (item) {
      item.querySelectorAll('[data-gpb-optional-choice]:checked').forEach(function (checkbox) {
        total += Number(checkbox.dataset.price || 0);
      });
    });

    return total;
  }

  function updateFormVariant(variant) {
    if (!variant) return;

    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var input = form.querySelector('input[name="id"], select[name="id"]');
    if (!input) return;

    input.value = variant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updatePrice(variant, builder) {
    if (!variant) return;

    var price = formatMoney(Number(variant.price || 0) + getAddonTotal(builder));
    var priceWrapper = document.querySelector('[id^="Price-"]');
    if (!priceWrapper) return;

    var priceEl = priceWrapper.querySelector('.m-price-item--regular, .m-price-item, .money, .price-item');
    if (priceEl) priceEl.textContent = price;
    else priceWrapper.textContent = price;
  }

  function updateTotal(builder, variant) {
    var total = builder.querySelector('[data-gpb-total]');
    if (total && variant) {
      total.textContent = formatMoney(Number(variant.price || 0) + getAddonTotal(builder));
    }
  }

  function updateImages(builder) {
    builder.querySelectorAll('[data-gpb-item]').forEach(function (item) {
      var img = item.querySelector('[data-gpb-image]');
      if (!img) return;

      var checked = item.querySelector('[data-gpb-optional-choice]:checked');
      var select = item.querySelector('[data-gpb-select]');
      var single = item.querySelector('[data-gpb-single]');
      var url = '';

      if (checked) url = checked.dataset.image;
      else if (select) url = select.options[select.selectedIndex].dataset.image;
      else if (single) url = single.dataset.image;

      if (url) img.src = url;
    });
  }

  function cleanLabel(label) {
    return String(label || '').replace(/^.*?\s-\s/, '').trim();
  }

  function updateProperties(builder) {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    form.querySelectorAll('[data-gpb-property]').forEach(function (el) {
      el.remove();
    });

    builder.querySelectorAll('[data-gpb-item]').forEach(function (item) {
      var role = item.dataset.priceRole;

      if (role === 'variant_match' || role === 'optional_variant' || role === 'variant_price_adjust') return;

      var label = cleanLabel(item.dataset.label);
      var value = selectedText(item);

      if (!label || !value) return;

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + label + ']';
      input.value = value;
      input.setAttribute('data-gpb-property', 'true');
      form.appendChild(input);
    });
  }

  function shortenMobileSelectOptions(builder) {
    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    builder.querySelectorAll('[data-gpb-select] option').forEach(function (option) {
      if (!option.dataset.fullText) option.dataset.fullText = clean(option.textContent);

      if (isMobile) {
        var text = option.dataset.fullText;
        text = text
          .replace(' Golf Simulator Enclosure Kit', '')
          .replace(' with Premium Impact Screen', '')
          .replace(' with High-Contrast Gray Impact Screen', ' - Gray Screen')
          .replace(' Curved Golf Enclosure Kit', ' Curved Enclosure');

        option.textContent = text;
      } else {
        option.textContent = option.dataset.fullText;
      }
    });
  }

  function sortItems(builder) {
    var list = builder.querySelector('.gpb__list');
    if (!list) return;

    Array.from(list.querySelectorAll('[data-gpb-item]'))
      .sort(function (a, b) {
        return Number(a.dataset.sortOrder || 999) - Number(b.dataset.sortOrder || 999);
      })
      .forEach(function (item) {
        list.appendChild(item);
      });
  }

  function sync(builder) {
    var variant = findVariant(builder);

    updateImages(builder);

    if (!variant) {
      var total = builder.querySelector('[data-gpb-total]');
      if (total) total.textContent = 'Variant not found';
      return;
    }

    updateFormVariant(variant);
    updatePrice(variant, builder);
    updateTotal(builder, variant);
    updateProperties(builder);
  }

  function init(builder) {
    sortItems(builder);
    shortenMobileSelectOptions(builder);

    builder
      .querySelectorAll('[data-gpb-item][data-price-role="optional_variant"] [data-gpb-optional-choice]')
      .forEach(function (checkbox) {
        checkbox.checked = false;
        checkbox.removeAttribute('checked');
      });

    sync(builder);

    builder.addEventListener('change', function (e) {
      var item = e.target.closest('[data-gpb-item]');
      if (!item) return;

      if (e.target.matches('[data-gpb-optional-choice]')) {
        if (e.target.checked && item.dataset.priceRole === 'optional_variant') {
          item.querySelectorAll('[data-gpb-optional-choice]').forEach(function (box) {
            if (box !== e.target) box.checked = false;
          });
        }
      }

      sync(builder);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gpb]').forEach(init);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-gpb]').forEach(init);
  });
})();
